export default __webpack_public_path__ + "static/media/poster_new-year.17177363.jpg";